import { navigate } from '@reach/router';
import { Warning } from '@material-ui/icons';
import strings from 'common/strings';
import {
  taskDetailsBuilder,
  vehicleDetailsBuilder,
  notesBuilder,
  locationBuilder,
  engageEngagementBuilder,
} from 'navigation/routes';
import {
  BriefcaseAccount,
  BriefcaseCheck,
  BriefcaseQuestion,
  BriefcaseX,
  NoteMention,
} from 'components/shared/icons';
import { Authentication, Location } from 'models';

const vehicleType = 'inventory';

export const iconColor = '#9E9E9E';
export const icons: Record<string, any> = {
  RECON_TASK_APPROVAL: BriefcaseQuestion,
  RECON_TASK_DENIED: BriefcaseX,
  RECON_TASK_ASSIGNED: BriefcaseAccount,
  RECON_TASK_COMPLETE: BriefcaseCheck,
  RECON_VEHICLE_GOAL_WARNING: Warning,
  RECON_VEHICLE_GOAL_DANGER: Warning,
  RECON_NOTE_MENTION: NoteMention,
} as const;

interface RequiredNotificationAttributes {
  parentType: string;
  parentId: string;
  locationId?: string;
  tenantId?: string;
  targetType: string;
  targetId: string;
}

const findRoute = (notification: RequiredNotificationAttributes) => {
  switch (notification.targetType) {
    case strings.TARGET_TYPE_TASK:
      return taskDetailsBuilder(notification.parentId);
    case strings.TARGET_TYPE_NOTE:
      return notesBuilder(notification.parentId);
    case strings.TARGET_TYPE_ENGAGEMENT:
      return engageEngagementBuilder(
        notification.parentId,
        false,
        notification.targetId
      );
    case strings.TARGET_TYPE_LOCATION:
      return locationBuilder(notification.parentId);
    default:
      return vehicleDetailsBuilder(notification.parentId);
  }
};

export const routeToNotification = async (
  notification: RequiredNotificationAttributes,
  onError: () => void,
  user: Authentication,
  currentLocation: Location,
  locationStatePageTitle = ''
) => {
  if (
    notification.parentType !== 'VEHICLE' ||
    (!notification.locationId && !notification.tenantId)
  )
    return;

  if (!user) {
    onError();
    return;
  }

  const notificationRooftopId =
    notification.locationId || notification.tenantId;

  if (notificationRooftopId !== currentLocation.id) {
    const notificationRooftop = user.locations.find(
      (rooftop) => rooftop.id === notificationRooftopId
    );
    if (!notificationRooftop) {
      onError();
      return;
    }
    await navigate(`/${notificationRooftop.id}/${vehicleType}`);
  }
  const route = findRoute(notification);
  navigate(route, { replace: true });
};
